import BaseContract from "../../BaseContract";

export default class BaseRoyaltiesContract extends BaseContract {}
